
import React from 'react';
import { PaymentsCard, payments_card_state } from "./deposits_card";
import {SetupPaymentCard, setup_payment_state} from "./setup_payment_card";
import { FundingSources, do_load_dwolla, funding_source_state } from "./funding_sources_card";
import { add_funding_source_state, funding_source_did_update} from "./add_funding_source_card";
import { withdrawal_card_state, WithdrawalCard } from "./withdrawal-card";
import { withdrawal_request_state } from "./withdrawal-request";
import { sprintf } from "sprintf-js";
import { MailDeposit } from "./mail-deposits-card";

class PaymentsDashboard extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      ...payments_card_state(),
      ...setup_payment_state(this),
      ...add_funding_source_state(this),
      ...withdrawal_card_state(this),
      ...funding_source_state(this),
      ...withdrawal_request_state(this),
      debug: false,
    };
  }

  componentDidMount = () => {
    if (this.props.username) {
      do_load_dwolla(this);
    } else {
      this.setState({
        dwolla: this.props.dwolla['0000'],
      })
    }
    document.addEventListener("keydown", this.onKeyPressed);
  };

  componentWillUnmount = () => {
    this.removeTimer();
    document.removeEventListener("keydown", this.onKeyPressed);
  }

  removeTimer = () => {
    if (this.cb) {
      window.clearTimeout(this.cb);
      delete this.cb;
    }
  }

  onKeyPressed = ev => {
    if (ev.code === "KeyD" && ev.ctrlKey) {
      ev.preventDefault();
      const debug = !this.state.debug;
      this.setState({ debug });
    }
  }

  componentDidUpdate = (prev_props) => {
    funding_source_did_update(this, prev_props);

    if (this.props.args.acct_index !== prev_props.args.acct_index) {
      //load_payment_info(this, false);
    }
  }

  getUserDashboard = () => {
    const username = this.props.username || this.props.user.username;
    const acct_index = this.props.acct_index;
    const acct_key = acct_index === "-1" ? "ALL" : sprintf("%04d", acct_index);
    if (!this.props.userDashboard
      || !this.props.userDashboard[username]) {
      return null;
    }
    return this.props.userDashboard[username][acct_key];
  }

  render = () => {

    return (
      <div className="container">
        <FundingSources component={this} />
        <SetupPaymentCard component={this} />
        <PaymentsCard component={this} />
        <WithdrawalCard component={this}/>
        <MailDeposit component={this}/>
      </div>
    )
  }
}

export { PaymentsDashboard };
